"use strict";
/*
Copyright 2021 Splunk Inc.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplunkWebTracerProvider = void 0;
const sdk_trace_web_1 = require("@opentelemetry/sdk-trace-web");
const api_1 = require("@opentelemetry/api");
class SplunkWebTracerProvider extends sdk_trace_web_1.WebTracerProvider {
    shutdown() {
        return new Promise((resolve) => {
            // TODO: upstream
            // note: BasicTracerProvider registers the propagator given to it in config
            // if the global propagator is the same as the one we registered, then we should deregister it
            api_1.propagation.disable();
            api_1.context.disable();
            api_1.trace.disable();
            resolve();
        }).then(() => super.shutdown());
    }
}
exports.SplunkWebTracerProvider = SplunkWebTracerProvider;
//# sourceMappingURL=SplunkWebTracerProvider.js.map